var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"atom-text"},_vm._l((_vm.lines),function(line,index){return _c('div',{key:index,domProps:{"innerHTML":_vm._s(line)}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }